import { render } from "./DigitalValueProposition.vue?vue&type=template&id=7f855605&scoped=true"
import script from "./DigitalValueProposition.vue?vue&type=script&lang=js"
export * from "./DigitalValueProposition.vue?vue&type=script&lang=js"

import "./DigitalValueProposition.vue?vue&type=style&index=0&id=7f855605&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f855605"]])

export default __exports__